<ng-container *ngIf="type === tablesTranslations.i18nCustomerData">

  <div class="esf-info-tile-grid__item"
       cdkDropList
       id="mergedCustomerData"
       cdkDropListConnectedTo="['firstCustomerData', 'secondCustomerData']"
       (cdkDropListDropped)="onDrop($event)">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text">{{ type }}</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--simple">
            <svg class="esf-icon esf-button__icon" width="16" height="16">
              <use xlink:href="#esf-icon-membership-small"></use>
            </svg>
            <span class="esf-button__icon-text"></span>
          </button>
        </span>
      </span>
    </h4>
    <div class="esf-info-tile">
      <div class="esf-info-tile__content">
        <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
          <div class="esf-grid__item">
            <div class="esf-icon-and-text esf-icon-and-text--xs">
              <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                <use xlink:href="#esf-icon-user-number"></use>
              </svg>
              <div [attr.required-text]="i18nRequiredText" class="esf-icon-and-text__text" [ngClass]="{
                'merge-field-required': !triggered && checkIfRequired('externalNumber'), 
                'merge-field-required-triggered': triggered && checkIfRequired('externalNumber')
                }">{{ customer?.externalNumber }}</div>
            </div>
          </div>

          <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.state">
            <a class="esf-tag" [ngClass]="customer?.state?.status?.class">{{ customer?.state?.status?.status }}</a>
          </div>

          <div class="esf-grid__item" *ngIf="!customer.state">
            <a class="esf-tag" style="visibility: hidden;">Status</a>
          </div>

        </div>
        <p>
          <small>
            <div [attr.required-text]="i18nRequiredText" [ngClass]="{
              'merge-field-required': !triggered && checkIfRequired('firstName'), 
              'merge-field-required-triggered': triggered && checkIfRequired('firstName')
              }">
              <span *ngIf="customer.firstName">
                <span class="name-prefix">{{ customer.salutation?.getTranslatedSalutation }} </span>
                <span class="title">{{ customer.title }} </span>
                <span class="firstName">{{ customer.firstName }} </span><span class="lastName">{{ customer.lastName }}</span>
                <br>
              </span>
            </div>
            <span *ngIf="customer.company">
              <span class="company">{{ customer.company }}</span>
              <br>
            </span>
            <div [attr.required-text]="i18nRequiredText" [ngClass]="{
              'merge-field-required': !triggered && checkIfRequired('birthday'), 
              'merge-field-required-triggered': triggered && checkIfRequired('birthday')
              }">
              <span *ngIf="customer.birthday">
                <span class="birthday">
                  {{ customer.birthday.date | date:customer.birthday.format }} - {{ getAge(customer.birthday.date) }}
                  <span i18n="After age number text@@customerOverviewComponent.text.yearsOld">years old</span>
                </span>
              </span>
            </div>
          </small>
        </p>

      </div>
    </div>
  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nComunicationData">

  <div class="esf-info-tile-grid__item"
       cdkDropList
       id="mergedCustomerCommunication"
       cdkDropListConnectedTo="['firstCustomerCommunication', 'secondCustomerCommunication']"
       (cdkDropListDropped)="onDrop($event)">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>
    <div class="esf-info-tile" style="flex: 1;">
      <div class="esf-info-tile__content">

        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nMobile">
            <use xlink:href="#esf-icon-tablet"></use>
          </svg>
          <div [attr.required-text]="i18nRequiredText" class="esf-icon-and-text__text" [ngClass]="{
            'merge-field-required': !triggered && checkIfRequired('mobile'), 
            'merge-field-required-triggered': triggered && checkIfRequired('mobile')
            }">{{ customer.mobile || '&nbsp;' }} </div>
        </div>
        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nTelephone">
            <use xlink:href="#esf-icon-phone"></use>
          </svg>
          <div [attr.required-text]="i18nRequiredText" class="esf-icon-and-text__text" [ngClass]="{
            'merge-field-required': !triggered && checkIfRequired('phone'), 
            'merge-field-required-triggered': triggered && checkIfRequired('phone')
            }">{{ customer.phone || '&nbsp;' }}</div>
        </div>

        <div class="esf-icon-and-text esf-icon-and-text--xs"
             [ngSwitch]="customer?.equalAuthorizationAndEmail">
          <ng-container *ngSwitchCase="true">
            <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nEmailAuthorization">
              <use xlink:href="#esf-icon-mail-authorized"></use>
            </svg>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <svg class="esf-icon" width="16" height="16" [attr.edsTooltip]="tooltipTranslations.i18nEmail">
              <use xlink:href="#esf-icon-mail"></use>
            </svg>
          </ng-container>

          <div [attr.required-text]="i18nRequiredText" class="esf-icon-and-text__text elipsis" [ngClass]="{
            'merge-field-required': !triggered && checkIfRequired('searchEmail'), 
            'merge-field-required-triggered': triggered && checkIfRequired('searchEmail')
            }">{{ customer.searchEmail || '&nbsp;' }}</div>
        </div>

      </div>
    </div>

  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nAttribute">

  <div class="esf-info-tile-grid__item">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>
    <div class="esf-info-tile"
         style="flex: 1;"
         cdkDropList
         id="mergedCustomerAttributes"
         cdkDropListConnectedTo="['firstCustomerAttributes', 'secondCustomerAttributes']"
         (cdkDropListDropped)="onDrop($event)">

      <ng-container *ngIf="customer['attributes'].length">
        <div class="esf-info-tile__content">
          <div class="flex-attributes">
            <div class="esf-tags attribute-padding" *ngFor="let attribute of customer['attributes']">
              <span [ngClass]="{'esf-tag--alert': attribute.status === 'inactive', 'text-color-dark': !attribute.isDark, 'text-color-light': attribute.isDark}"
                    [style.background-color]="attribute.color"
                    (click)="removeItem(attribute)"
                    [class.cdk-drag-placeholder]="!attribute"
                    class="esf-tag">{{attribute.name}}
              </span>
            </div>

            <div class="esf-tags attribute-padding"
                 style="visibility: hidden;"
                 *ngIf="customer['attributes']">
              <span class="esf-tag">Attribute</span>
            </div>
          </div>

        </div>
      </ng-container>

      <ng-container *ngIf="customer['attributes'].length === 0">
        <div class="esf-grid__item">
          <section class="esf-empty-state flex-empty-state"
                   app-empty-state
                   [emptyStateIcon]="'#esf-icon-attributes'"
                   [emptyStateText]="tablesTranslations.i18nDragAttributes">
          </section>
        </div>
      </ng-container>
    </div>
  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nMembership">

  <div class="esf-info-tile-grid__item">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>

    <div class="esf-info-tile"
         cdkDropList
         id="mergedCustomerMembership"
         cdkDropListConnectedTo="['firstCustomerMembership', 'secondCustomerMembership']"
         (cdkDropListDropped)="onDrop($event)">
      <ng-container *ngIf="customer.membership">
        <div class="esf-info-tile__content">

          <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
            <div class="esf-grid__item">
              <div class="esf-icon-and-text esf-icon-and-text--xs">
                <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                  <use xlink:href="#esf-icon-membership-number"></use>
                </svg>
                <div class="esf-icon-and-text__text">{{ customer.membership?.membershipNumber || '' }}</div>
              </div>
            </div>
            <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.membership.status.class">
              <a class="esf-tag" [ngClass]="customer.membership?.status?.class">{{ customer.membership?.status?.status || '/' }}</a>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!customer.membership">
        <div class="esf-grid__item">
          <section class="esf-empty-state flex-empty-state"
                   [attr.required-text]="i18nRequiredText"
                   [ngClass]="{
                    'merge-field-required': !triggered && checkIfRequired('membership'), 
                    'merge-field-required-triggered': triggered && checkIfRequired('membership')
                    }"
                   app-empty-state
                   [emptyStateIcon]="'#esf-icon-membership-number'"
                   [emptyStateText]="tablesTranslations.i18nDragMembership">
          </section>
        </div>
      </ng-container>

    </div>
  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nMembershipCampai">

  <div class="esf-info-tile-grid__item">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>

    <div class="esf-info-tile"
         cdkDropList
         id="mergedCustomerMembership"
         cdkDropListConnectedTo="['firstCustomerMembership', 'secondCustomerMembership']"
         (cdkDropListDropped)="onDrop($event)">
      <ng-container *ngIf="customer.campaiMembership">
        <div class="esf-info-tile__content">

          <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
            <div class="esf-grid__item">
              <div class="esf-icon-and-text esf-icon-and-text--xs">
                <svg class="esf-icon esf-icon-and-text__icon" width="16" height="16">
                  <use xlink:href="#esf-icon-membership-number"></use>
                </svg>
                <div class="esf-icon-and-text__text">{{ customer.campaiMembership?.membershipNumber || '' }}</div>
              </div>
            </div>
            <div class="esf-grid__item" [class.cdk-drag-placeholder]="!customer.campaiMembership.status.class">
              <a class="esf-tag" [ngClass]="customer.campaiMembership?.status?.class">{{ customer.campaiMembership?.status?.status || '/' }}</a>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!customer.campaiMembership">
        <div class="esf-grid__item">
          <section class="esf-empty-state flex-empty-state"
                   [attr.required-text]="i18nRequiredText"
                   [ngClass]="{
                    'merge-field-required': !triggered && checkIfRequired('campaiMembership'), 
                    'merge-field-required-triggered': triggered && checkIfRequired('campaiMembership')
                    }"
                   app-empty-state
                   [emptyStateIcon]="'#esf-icon-membership-number'"
                   [emptyStateText]="tablesTranslations.i18nDragMembership">
          </section>
        </div>
      </ng-container>

    </div>
  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nStandardAddress">

  <div class="esf-info-tile-grid__item">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>
    <div class="esf-info-tile"
         style="flex: 1;"
         cdkDropList
         id="mergedCustomerStandardAddress"
         cdkDropListConnectedTo="['firstCustomerStandardAddress', 'secondCustomerStandardAddress']"
         (cdkDropListDropped)="onDrop($event)">

      <ng-container *ngIf="getAddresses('standard').length">
        <div class="esf-info-tile__content">
          <p *ngFor="let address of getAddresses('standard')">
            <span class="street">{{ address.street }} </span><br>
            <span class="city">{{ address.postalCode }} {{ address.city }}</span><br>
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="getAddresses('standard').length === 0">
        <div class="esf-grid__item">
          <section class="esf-empty-state flex-empty-state"
                   [attr.required-text]="i18nRequiredText"
                   [ngClass]="{
                    'merge-field-required': !triggered && checkIfRequired('addresses'), 
                    'merge-field-required-triggered': triggered && checkIfRequired('addresses')
                    }"
                   app-empty-state
                   [emptyStateIcon]="'#esf-icon-location'"
                   [emptyStateText]="tablesTranslations.i18nDragAddress">
          </section>
        </div>
      </ng-container>

    </div>

  </div>

</ng-container>

<ng-container *ngIf="type === tablesTranslations.i18nAddresses">

  <div class="esf-info-tile-grid__item">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
      <span class="esf-action-heading__text">{{ type }}</span>
    </h4>
    <div class="esf-info-tile"
         style="flex: 1;"
         cdkDropList
         id="mergedCustomerAddresses"
         cdkDropListConnectedTo="['firstCustomerAddresses', 'secondCustomerAddresses']"
         (cdkDropListDropped)="onDrop($event)">

      <ng-container *ngIf="getAddresses().length">
        <div class="esf-info-tile__content">
          <p *ngFor="let address of getAddresses()">
            <span class="full-name">{{ address.firstName }} {{ address.lastName }}</span><br>
            <span class="street">{{ address.street }}</span><br>
            <span class="city">{{ address.postalCode }} {{ address.city }}</span><br>
          </p>
        </div>
      </ng-container>

      <ng-container *ngIf="getAddresses().length === 0">
        <div class="esf-grid__item">
          <section class="esf-empty-state flex-empty-state"
                   app-empty-state
                   [emptyStateIcon]="'#esf-icon-location'"
                   [emptyStateText]="tablesTranslations.i18nDragAddress">
          </section>
        </div>
      </ng-container>

    </div>

  </div>

</ng-container>
